<template>
  <div>
    <div class="dialog-content">
      <ElTabs class="tab-default tab-sm tab-bg text-dark tab-dialog-tabs pt-10" v-model="activeName">
        <Tab-pane :label="$t('CHARGES')" name="Charges">
          <div v-if="isLoadingDetails" class="status-msg my-md">
            <span>
              <img :src="Payments" width="240" height="175" alt=""/>
              <p class="mt-m40">{{ $t("LOADING_DETAILS") }}</p>
            </span>
          </div>
          <div v-else>
            <charge-details
              :extraKmCharge="extraKmCharge"
              :initialExtraKmCharge="initialExtraKmCharge"
              :paymentSettings="paymentSettings"
              :filteredChargesHeaders="filteredChargesHeaders"
              :consigneeDetails="rowInfo.consignee_data[0]"
              :chargeComments="chargeComments"
              :editable="editable"
              :indent="indent"
              :paymentId="paymentId"
              :consigneeDataId="consigneeDataId"
              :orderType="orderType"
              :rowChargeStatus="rowChargeStatus"
              :showTransporterDebit="showTransporterDebit"
              :debitAdjustCharge="debitAdjustCharge"
              :transporterDebitCharge="indent.consignee_data[0].transporter_debit"
              :orderMovement="orderMovement"
              :clientConfig="clientConfig"
              :isShipperChargesFeatureEnabled="isShipperChargesFeatureEnabled"
              @preview="preview"
              @save="save"
              />
          </div>
        </Tab-pane>
        <Tab-pane :label="$t('DETAILS')" name="Details">
          <div v-if="isLoadingDetails" class="status-msg my-md">
            <span>
              <img :src="Payments" width="240" height="175" alt=""/>
              <p class="mt-m40">{{ $t('LOADING_DETAILS') }}</p>
            </span>
          </div>
          <div  v-else class="tab-content pb-0">
            <trip-details
            :indent="indent"
            @preview="preview"
            />
          </div>
        </Tab-pane>
        <Tab-pane :label="$t('TIMELINE')" name="Timeline">
          <div v-if="isLoadingDetails" class="status-msg my-md">
            <span>
              <img :src="Payments" width="240" height="175" alt=""/>
              <p class="mt-m40">{{ $t('LOADING_DETAILS') }}</p>
            </span>
          </div>
          <div  v-else class="tab-content pb-0">
            <timeline-details
            :timelineDetails="indent.timelines"
            />
          </div>
        </Tab-pane>
      </ElTabs>
    </div>
  </div>
</template>

<script>
import TimelineDetails from './TimelineDetails';
import TripDetails from './TripDetails';
import ChargeDetails from '../payments/ChargeDetails';
import Payments from '@common/asset/images/payments.gif';

export default {
  name: 'row-details',
  components: {
    ChargeDetails,
    TimelineDetails,
    TripDetails,
  },
  props: {
    indent: {
      type: Object,
    },
    extraKmCharge: {
      default: 0,
    },
    initialExtraKmCharge: {
      type: Number,
      default: 0,
    },
    rowInfo: {
      type: Object,
    },
    filteredChargesHeaders: {
      type: Array,
    },
    paymentId: {
      type: Number,
    },
    consigneeDataId: {
      type: Number,
    },
    paymentSettings: {
      type: Object,
    },
    orderType: {
      type: Number,
      default: null,
    },
    rowChargeStatus: null,
    editable: {
      type: Boolean,
      default: false,
    },
    chargeComments: {
      type: Object,
    },
    showTransporterDebit: {
      type: Boolean,
      default: false,
    },
    debitAdjustCharge: {
      type: Number,
      default: 0,
    },
    activeName: {
      type: String,
      default: 'Charges',
    },
    isLoadingDetails: {
      type: Boolean,
      default: true,
    },
    clientConfig: {
      type: Object,
      default: () => ({}),
    },
    orderMovement: null,
    isShipperChargesFeatureEnabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      Payments,
      transporterCharges: {},
      originalTransporterCharges: {},
      shipperCharges: {},
      discrepancyCharges: {},
      changedCharge: {},
      dialogImageUrl: '',
      dialogVisible: false,
      chargesChanged: false,
      debitAdjustValue: 0,
      transporterDebitCharge: {},
      commentIds: {},
      commentsList: {},
      defaultComments: {},
      mandatoryCommentAttachment: {},
      consigneeDetails: {},
      rowDetails: {},
      commentId: null,
    };
  },
  methods: {
    preview(data) {
      this.$emit('showPreview', data);
    },
    save(updatedData, closeDialog) {
      this.$emit('save', updatedData, closeDialog);
    },
  },
};
</script>
